import React, { useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import listPlugin from '@fullcalendar/list';
import { useAuth } from 'context/AuthProvider';
import { httpClient } from 'helpers/HttpClient';
import PropTypes from 'prop-types';
import { ApiEndpoint } from 'helpers/ApiEndPoint';
import MyModal from 'helpers/MyModal';
import EventsList from 'pages/Operations/EventsList';
import BtnExportToExcell from 'componentes/generic/ExportToExcel';
import {
  Button,
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormatDateToDb, FormatTime } from 'helpers/FormatData';
const URI = ApiEndpoint + 'operations/';
const CalendarWeek = () => {
  const calendarRef = useRef();
  const Auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  var userData = Auth.getSessionData();
  const [data, setData] = useState([]);
  const [dataToExport, setDataToExport] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [currentStartDate, setCurrentStartDate] = useState(
    getMonday(new Date())
  );
  const [openModalDay, setOpenModalDay] = useState(false);
  const previousRange = useRef({ start: null, end: null });

  function getMonday(date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = day === 0 ? -6 : 1 - day; // Sunday → Monday
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  const handleCloseModalDay = () => {
    setOpenModalDay(false);
  };
  const handleEventClick = info => {
    if (info.event.url) {
      window.open(info.event.url);
      info.jsEvent.preventDefault();
    } else {
      setSelectedDate(FormatDateToDb(info.event.start));
      setOpenModalDay(true);
      // setModalEventContent(info);
      // setIsOpenEventModal(true);
    }
  };
  function handleDatesSet(arg) {
    const monday = getMonday(arg.start);

    safeGetCalendarData(monday, arg.end);
  }
  function handleCustomPrev() {
    const newStart = new Date(currentStartDate);
    newStart.setDate(newStart.getDate() - 7); // Go back 1 week
    setCurrentStartDate(newStart);
  }

  function handleCustomNext() {
    const newStart = new Date(currentStartDate);
    newStart.setDate(newStart.getDate() + 7); // Go forward 1 week
    setCurrentStartDate(newStart);
  }

  useEffect(() => {
    if (
      calendarRef.current &&
      typeof calendarRef.current.getApi === 'function'
    ) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(currentStartDate); // This updates the calendar view
    }
  }, [currentStartDate]);

  const safeGetCalendarData = (start, end) => {
    const prev = previousRange.current;
    if (
      prev.start?.getTime() === start.getTime() &&
      prev.end?.getTime() === end.getTime()
    ) {
      return;
    }
    previousRange.current = { start, end };
    getCalendarData(start, end);
  };
  const getCalendarData = async (dateFrom, dateTo) => {
    setData(null);
    setIsLoading(true);
    console.log('dateTo', dateTo);
    setDataToExport(null);
    httpClient(
      'POST',
      URI + 'calendar/',
      {
        from: dateFrom,
        to: FormatDateToDb(dateTo)
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          let dataReport = response.data;
          const renamedData = dataReport.map(item => ({
            Fecha: new Date(item.start).toLocaleDateString('es-MX', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            }),
            Hora: FormatTime(item.start),
            Expediente: item.title.split('|')[0],
            Consumidor: item.title.split('|')[1].split('-')[0],
            Delegacion: item.location,
            Formato: item.formato,
            Folio: item.folioext,
            Pedido: item.numeropedido,
            motivo: item.description
          }));
          setDataToExport(renamedData);
          const eventList = response.data.reduce(
            (acc, event) =>
              event.schedules
                ? acc.concat(event.schedules.concat(event))
                : acc.concat(event),
            []
          );
          const normalized = eventList.map(
            ({ classname, start, end, ...rest }) => ({
              ...rest,
              className: classname,
              start: new Date(start.replace('Z', '')),
              end: new Date(end.replace('Z', ''))
            })
          );
          setData(normalized);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const eventTimeFormat = {
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: false,
    meridiem: true
  };

  const EventItem = ({ info }) => {
    const { event } = info;

    return (
      <>
        {info.view.type == 'listWeek' ? (
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="me-2">
                <span className="fw-bold">
                  {event.title}/ {event.extendedProps.consumidor}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <div className="me-2">
              <span className="fw-bold">{event.title}</span>
            </div>
          </div>
        )}
      </>
    );
  };

  EventItem.propTypes = {
    info: PropTypes.object
  };

  useEffect(() => {
    if (
      calendarRef.current &&
      typeof calendarRef.current.getApi === 'function'
    ) {
      const api = calendarRef.current.getApi();

      const { activeRange } = api.getCurrentData().dateProfile;

      getCalendarData(activeRange.start, activeRange.end);
    }
  }, []);
  return (
    <>
      <Card>
        <Card.Header>
          {' '}
          <Row className="align-items-center gx-0">
            <Col xs="auto" className="d-flex justify-content-end order-md-1">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip style={{ position: 'fixed' }} id="nextTooltip">
                    Anterior
                  </Tooltip>
                }
              >
                <Button
                  variant="link"
                  className="icon-item p-0 me-1 ms-md-2"
                  onClick={handleCustomPrev}
                >
                  <FontAwesomeIcon icon="arrow-left" />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip style={{ position: 'fixed' }} id="previousTooltip">
                    Siguiente
                  </Tooltip>
                }
              >
                <Button
                  variant="link"
                  className="icon-item p-0 me-lg-2"
                  onClick={handleCustomNext}
                >
                  <FontAwesomeIcon icon="arrow-right" />
                </Button>
              </OverlayTrigger>
            </Col>
            <Col xs="auto" className="d-flex justify-content-end order-md-2">
              <h4>
                Semana: {currentStartDate.toLocaleDateString()} al{' '}
                {new Date(
                  currentStartDate.getTime() + 7 * 24 * 60 * 60 * 1000
                ).toLocaleDateString()}
              </h4>
            </Col>

            <Col md="auto" className="d-md-none">
              <hr />
            </Col>

            <Col className="d-flex justify-content-end order-md-2">
              <BtnExportToExcell
                dataReport={dataToExport}
                fileName="Agenda por Periodo"
              />
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="p-0 app-calendar">
          <FullCalendar
            ref={calendarRef}
            plugins={[listPlugin]}
            initialView="list"
            headerToolbar={false} // Hide default toolbar
            views={{
              list: {
                type: 'list',
                duration: { days: 8 },
                buttonText: '8-day list'
              }
            }}
            initialDate={currentStartDate}
            eventTimeFormat={eventTimeFormat}
            eventClick={handleEventClick}
            visibleRange={() => {
              const start = new Date(currentStartDate);
              const end = new Date(start);
              end.setDate(start.getDate() + 8); // 8 days

              return { start, end };
            }}
            eventContent={info => <EventItem info={info} />}
            datesSet={handleDatesSet}
            events={data || []}
          />{' '}
        </Card.Body>
      </Card>
      {openModalDay && (
        <MyModal
          id="id_myModal"
          title={'Lista de Eventos '}
          openModal={openModalDay}
          closeModal={handleCloseModalDay}
        >
          <EventsList selectedDate={selectedDate}></EventsList>
        </MyModal>
      )}
      {isLoading && (
        <div className="loader-overlay">
          <span className="loader">Cargando Eventos...</span>
        </div>
      )}
    </>
  );
};

export default CalendarWeek;
